import React from 'react';
import styled, { css } from 'styled-components';
import { MQ_FOR_PHONE_WIDTH, MQ_FOR_TABLET_PORTRAIT_UP_NO_MIN_HEIGHT } from 'web-ui-kit/media';
import { Header5LargeStyles } from 'web-ui-kit/typography';
import { backgroundLightM, surfaceM, quarterTransparentBlack, grayLightM } from 'web-ui-kit/colors';
import HeadsetIcon from 'web-ui-kit/assets/HeadsetIcon';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function SupportButtonLargeScreen(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return (
    /*#__PURE__*/
    React.createElement(Button, {
      onClick: onClick
    },
    /*#__PURE__*/
    React.createElement(IconContainer, null,
    /*#__PURE__*/
    React.createElement(Icon, null)),
    /*#__PURE__*/
    React.createElement(Title, null, "Support"))
  );
}

var Button = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: 2rem;\n  box-shadow: 0 .25rem .25rem ", ";\n  outline: none;\n  cursor: pointer;\n  width: 9.8125rem;\n  height: 4.25rem;\n  ", " {\n    display: none;\n  }\n  display: flex;\n  align-items: center;\n"])), backgroundLightM, surfaceM, quarterTransparentBlack, MQ_FOR_PHONE_WIDTH);
var IconContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 50%;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n  width: 3.25rem;\n  height: 3.25rem;\n  margin-right: 0.5rem;\n"])), surfaceM);
var Icon = styled(HeadsetIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n"])));
var Title = styled.h5(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  margin-right: 1.5rem;\n"])), Header5LargeStyles);

var _templateObject$1, _templateObject2$1;

function SupportButtonSmallScreen(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return (
    /*#__PURE__*/
    React.createElement(Button$1, {
      onClick: onClick
    },
    /*#__PURE__*/
    React.createElement(Icon$1, {
      variant: "helpSmall"
    }))
  );
}

var Button$1 = styled.button(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 50%;\n  outline: none;\n  cursor: pointer;\n  width: 3.5rem;\n  height: 3.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", " {\n    display: none;\n  }\n"])), surfaceM, grayLightM, MQ_FOR_TABLET_PORTRAIT_UP_NO_MIN_HEIGHT);
var Icon$1 = styled(HeadsetIcon)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  padding: auto;\n"])));

var _templateObject$2, _templateObject2$2;

var ZendeskSupportButton =
/*#__PURE__*/
React.forwardRef(function ZendeskSupportButton(_ref, ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$rightPos = _ref.rightPos,
      rightPos = _ref$rightPos === void 0 ? 0 : _ref$rightPos,
      _ref$zendeskOpen = _ref.zendeskOpen,
      zendeskOpen = _ref$zendeskOpen === void 0 ? false : _ref$zendeskOpen;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      className: className,
      id: "zendesk-support-button",
      ref: ref,
      rightPos: rightPos,
      zendeskOpen: zendeskOpen
    },
    /*#__PURE__*/
    React.createElement(SupportButtonLargeScreen, {
      onClick: onClick
    }),
    /*#__PURE__*/
    React.createElement(SupportButtonSmallScreen, {
      onClick: onClick
    }))
  );
});
var Container = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 1rem;\n  transition: right 0.2s ease-in-out;\n  right: ", "px;\n  z-index: 25;\n  ", " {\n    right: ", "px;\n  }\n  ", "\n"])), function (_ref2) {
  var rightPos = _ref2.rightPos;
  return rightPos + 8;
}, MQ_FOR_PHONE_WIDTH, function (_ref3) {
  var rightPos = _ref3.rightPos;
  return rightPos + 8;
}, function (_ref4) {
  var zendeskOpen = _ref4.zendeskOpen;
  return zendeskOpen && css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    display: none;\n  "])));
});
export default ZendeskSupportButton;